<thumbnail-selector 
	*ngIf="asset && project && project.thumbnails"
	[asset]="asset"
	[isProject]="true"
	(onChange)="thumbnailsChanged($event)"
	[thumbnails]="project.thumbnails"
	[assetTitle]="project.title"
></thumbnail-selector>
